module.exports = __webpack_public_path__ + "static/media/badetassen.3b4dec82.svg";